(function () {
    'use strict';

    angular
        .module('app')
        .factory('CarryoverData', ['$rootScope', function ($rootScope) {
            var data = [];
            var c = 0;
            return {
                data: data,
                update: function (inData) {
                    inData.AsiaVolume = 0;
                    inData.C4CVolume = 0;
                    inData.CAVolume = 0;
                    inData.CNVolume = 0;
                    inData.EuDtcVolume = 0;
                    inData.NaDtcStoreVolume = 0;
                    inData.NaDtcEcomVolume = 0;
                    inData.ItalyVolume = 0;
                    inData.Emea3pVolume = 0;
                    inData.EmeaDistVolume = 0;
                    inData.HKVolume = 0;
                    inData.IntnlVolume = 0;
                    inData.USVolume = 0;
                    inData.EmeaOwnedVolume = 0;
                    inData.LatinAVolume = 0;
                    inData.TotalVolume = 0;
                    inData.calculateEstimatedVolume = 0;
                    inData.calcTotalVolumes = 0;
                    inData.calculateTotalVolumes = 0;

                    this.data.push(inData);
                },
                reset: function () {
                    //this.data = [];
                    for (var i = 0; i < data.length; i++) {
                        this.data = [];
                    }
                },
                remove: function (index) {
                    this.data.splice(index, 0);
                }
            };
        }]);
})();
